export default "__VITE_ASSET__DAlbh0Zs__"